export const SET_HRMS62E_INDEX_DISP = 'SET_HRMS62E_INDEX_DISP'
export const GET_HRMS62E_INDEX_DISP = 'GET_HRMS62E_INDEX_DISP'
export const SET_HRMS62E_DETAIL_DISP = 'SET_HRMS62E_DETAIL_DISP'
export const GET_HRMS62E_DETAIL_DISP = 'GET_HRMS62E_DETAIL_DISP'
export const GET_HRMS62E_MAX_ROWSPAN = 'GET_HRMS62E_MAX_ROWSPAN'
export const SET_HRMS62E_COLUMNS = 'SET_HRMS62E_COLUMNS'
export const GET_HRMS62E_COLUMNS = 'GET_HRMS62E_COLUMNS'
export const SET_HRMS62E_LABELS = 'SET_HRMS62E_LABELS'
export const GET_HRMS62E_LABELS = 'GET_HRMS62E_LABELS'
export const RECEIVED_HRMS62E_COLUMNS_LABELS = 'RECEIVED_HRMS62E_COLUMNS_LABELS'
export const SET_HRMS62E_INDEX = 'SET_HRMS62E_INDEX'
export const GET_HRMS62E_INDEX = 'GET_HRMS62E_INDEX'
export const SET_HRMS62E_INDEX_SELECTED = 'SET_HRMS62E_INDEX_SELECTED'
export const GET_HRMS62E_INDEX_SELECTED = 'GET_HRMS62E_INDEX_SELECTED'
export const RECEIVED_HRMS62E_INDEX = 'RECEIVED_HRMS62E_INDEX'
export const RECEIVED_HRMS62E_CREATE = 'RECEIVED_HRMS62E_CREATE'
export const SET_HRMS62E_DETAIL = 'SET_HRMS62E_DETAIL'
export const GET_HRMS62E_DETAIL = 'GET_HRMS62E_DETAIL'
export const RECEIVED_HRMS62E_DETAIL = 'RECEIVED_HRMS62E_DETAIL'
export const SET_HRMS62E_DROPDOWNS = 'SET_HRMS62E_DROPDOWNS'
export const GET_HRMS62E_DROPDOWNS = 'GET_HRMS62E_DROPDOWNS'
export const RECEIVED_HRMS62E_DROPDOWNS = 'RECEIVED_HRMS62E_DROPDOWNS'
export const TOGGLE_HRMS62E_PAGE = 'TOGGLE_HRMS62E_PAGE'
export const POST_HRMS62E_SAVE = 'POST_HRMS62E_SAVE'
export const POST_HRMS62E_CANCEL = 'POST_HRMS62E_CANCEL'
export const GET_HRMS62E_ENTITLE_FLAG_LEAVE = 'GET_HRMS62E_ENTITLE_FLAG_LEAVE'
export const SET_HRMS62E_ENTITLE_FLAG_LEAVE = 'SET_HRMS62E_ENTITLE_FLAG_LEAVE'
export const RECEIVED_HRMS62E_ENTITLE_FLAG_LEAVE = 'RECEIVED_HRMS62E_ENTITLE_FLAG_LEAVE'
export const GET_HRMS62E_WORKTIME = 'GET_HRMS62E_WORKTIME'
export const SET_HRMS62E_WORKTIME = 'SET_HRMS62E_WORKTIME'
export const RECEIVED_HRMS62E_WORKTIME = 'RECEIVED_HRMS62E_WORKTIME'
export const GET_HRMS62E_POPUP = 'GET_HRMS62E_POPUP'
export const SET_HRMS62E_POPUP = 'SET_HRMS62E_POPUP'
export const RECEIVED_HRMS62E_POPUP = 'RECEIVED_HRMS62E_POPUP'
export const SET_HRMS62E_CODLEAVE = 'SET_HRMS62E_CODLEAVE'
export const RECEIVED_HRMS62E_CODLEAVE = 'RECEIVED_HRMS62E_CODLEAVE'



// WEBPACK FOOTER //
// ./src/store/modules/hrms62e/mutation-types.js